import React from 'react'

export const showTitle = (node)=> {
  if (node.showTitle === false) {
    return
  } 
  return <h2>{node.title}</h2>
}